import { lazy } from 'react';

// ----------------------------------------------------------------------

const LoginPage = lazy(() => import('../pages/Login.page'));
const NewPasswordPage = lazy(() => import('../pages/NewPassword.page'));
// ----------------------------------------------------------------------

const LoginRoutes = [
    {
        path: '/login',
        element: <LoginPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/new-password',
        element: <NewPasswordPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { LoginRoutes };
